import React, { useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const privacyContent = <div className="space-y-4" data-id="element-62">
      <h3 className="text-2xl font-bold font-serif text-forest" data-id="element-63">
        Política de Privacidad
      </h3>
      <p className="text-forest/70 text-sm italic" data-id="element-64">
        Última actualización: febrero 2026
      </p>

      <div className="space-y-4 text-forest/80 leading-relaxed" data-id="element-65">
        <section data-id="element-66">
          <h4 className="font-semibold text-forest mb-2" data-id="element-67">
            1. Información que recopilamos
          </h4>
          <p data-id="element-68">
            Al adquirir PequeSalud Natural, recopilamos únicamente la
            información necesaria para procesar tu compra: nombre, dirección de
            correo electrónico y datos de pago. No almacenamos información de
            tarjetas de crédito directamente.
          </p>
        </section>

        <section data-id="element-69">
          <h4 className="font-semibold text-forest mb-2" data-id="element-70">
            2. Uso de la información
          </h4>
          <p data-id="element-71">Tu información personal se utiliza exclusivamente para:</p>
          <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-72">
            <li data-id="element-73">Procesar y entregar tu compra digital.</li>
            <li data-id="element-74">Enviarte el enlace de descarga del producto.</li>
            <li data-id="element-75">
              Comunicarnos contigo en caso de ser necesario respecto a tu
              pedido.
            </li>
          </ul>
        </section>

        <section data-id="element-76">
          <h4 className="font-semibold text-forest mb-2" data-id="element-77">
            3. Protección de datos
          </h4>
          <p data-id="element-78">
            Implementamos medidas de seguridad razonables para proteger tu
            información personal. No vendemos, intercambiamos ni transferimos tu
            información a terceros sin tu consentimiento.
          </p>
        </section>

        <section data-id="element-79">
          <h4 className="font-semibold text-forest mb-2" data-id="element-80">4. Cookies</h4>
          <p data-id="element-81">
            Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
            navegación. Puedes configurar tu navegador para rechazar cookies,
            aunque esto podría afectar algunas funcionalidades.
          </p>
        </section>

        <section data-id="element-82">
          <h4 className="font-semibold text-forest mb-2" data-id="element-83">5. Tus derechos</h4>
          <p data-id="element-84">
            Tienes derecho a acceder, rectificar o eliminar tus datos personales
            en cualquier momento. Para ejercer estos derechos, puedes
            comunicarte con nosotros a través de los canales disponibles.
          </p>
        </section>
      </div>
    </div>;
  const termsContent = <div className="space-y-4" data-id="element-85">
      <h3 className="text-2xl font-bold font-serif text-forest" data-id="element-86">
        Términos y Condiciones
      </h3>
      <p className="text-forest/70 text-sm italic" data-id="element-87">
        Última actualización: febrero 2026
      </p>

      <div className="space-y-4 text-forest/80 leading-relaxed" data-id="element-88">
        <section data-id="element-89">
          <h4 className="font-semibold text-forest mb-2" data-id="element-90">
            1. Producto digital
          </h4>
          <p data-id="element-91">
            PequeSalud Natural es un producto digital (ebook en formato PDF) que
            se entrega de forma inmediata tras la compra. Al completar tu
            compra, recibirás acceso instantáneo para descargar la guía.
          </p>
        </section>

        <section data-id="element-92">
          <h4 className="font-semibold text-forest mb-2" data-id="element-93">2. Uso permitido</h4>
          <p data-id="element-94">
            La guía es para uso personal y familiar únicamente. Queda prohibida
            su reproducción, distribución, reventa o compartición total o
            parcial sin autorización expresa.
          </p>
        </section>

        <section data-id="element-95">
          <h4 className="font-semibold text-forest mb-2" data-id="element-96">
            3. Descargo de responsabilidad médica
          </h4>
          <p data-id="element-97">
            PequeSalud Natural es una guía informativa complementaria.{' '}
            <strong data-id="element-98">
              No sustituye el consejo, diagnóstico o tratamiento médico
              profesional.
            </strong>{' '}
            Siempre consulta a tu pediatra o profesional de la salud ante
            cualquier duda sobre la salud de tu hijo.
          </p>
        </section>

        <section data-id="element-99">
          <h4 className="font-semibold text-forest mb-2" data-id="element-100">
            4. Garantía de devolución
          </h4>
          <p data-id="element-101">
            Ofrecemos una garantía de satisfacción de 7 días. Si no estás
            conforme con el producto, puedes solicitar un reembolso completo
            dentro de los 7 días posteriores a la compra, sin preguntas.
          </p>
        </section>

        <section data-id="element-102">
          <h4 className="font-semibold text-forest mb-2" data-id="element-103">
            5. Limitación de responsabilidad
          </h4>
          <p data-id="element-104">
            PequeSalud Natural y sus creadores no se hacen responsables de los
            resultados obtenidos con el uso de la guía. Los remedios naturales
            presentados son complementarios y cada niño puede reaccionar de
            manera diferente.
          </p>
        </section>

        <section data-id="element-105">
          <h4 className="font-semibold text-forest mb-2" data-id="element-106">6. Modificaciones</h4>
          <p data-id="element-107">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Los cambios serán efectivos desde su publicación en esta
            página.
          </p>
        </section>
      </div>
    </div>;
  return <>
      <footer className="bg-forest text-cream/60 py-12 border-t border-white/10" data-id="element-108">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-109">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-110">
            <div className="text-center md:text-left" data-id="element-111">
              <span className="font-serif text-xl font-bold text-cream tracking-tight block mb-2" data-id="element-112">
                PequeSalud <span className="text-terracotta" data-id="element-113">Natural</span>
              </span>
              <p className="text-sm max-w-md" data-id="element-114">
                Acompañando a madres con soluciones naturales y sentido común.
              </p>
            </div>

            <div className="flex flex-col items-center md:items-end gap-3" data-id="element-115">
              <div className="flex items-center gap-4" data-id="element-116">
                <button onClick={() => setActiveModal('privacy')} className="text-sm text-cream/60 hover:text-terracotta-light transition-colors underline underline-offset-2 decoration-cream/20 hover:decoration-terracotta-light" data-id="element-117">
                  Privacidad
                </button>
                <span className="text-cream/20" data-id="element-118">|</span>
                <button onClick={() => setActiveModal('terms')} className="text-sm text-cream/60 hover:text-terracotta-light transition-colors underline underline-offset-2 decoration-cream/20 hover:decoration-terracotta-light" data-id="element-119">
                  Términos y Condiciones
                </button>
              </div>
              <p className="text-sm" data-id="element-120">
                &copy; {new Date().getFullYear()} PequeSalud Natural. Todos los
                derechos reservados.
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-white/10 text-xs text-center text-cream/40 max-w-3xl mx-auto" data-id="element-121">
            <p data-id="element-122">
              DESCARGO DE RESPONSABILIDAD: PequeSalud Natural es una guía
              informativa complementaria basada en remedios naturales
              tradicionales. No sustituye el consejo, diagnóstico o tratamiento
              médico profesional. Consulta siempre a tu pediatra o profesional
              de la salud ante cualquier duda sobre la salud de tu hijo. Si
              crees que tienes una emergencia médica, llama a tu médico o al
              servicio de emergencias inmediatamente.
            </p>
          </div>
        </div>
      </footer>

      {/* Modal Popup */}
      <AnimatePresence data-id="element-123">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-124">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-forest/60 backdrop-blur-sm" data-id="element-125" />

            {/* Modal Content */}
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} onClick={e => e.stopPropagation()} className="relative bg-cream rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden" data-id="element-126">
              {/* Close Button */}
              <div className="sticky top-0 bg-cream/95 backdrop-blur-sm border-b border-sage/10 px-6 py-4 flex justify-between items-center z-10" data-id="element-127">
                <span className="text-sm font-semibold text-forest/50 uppercase tracking-wide" data-id="element-128">
                  {activeModal === 'privacy' ? 'Privacidad' : 'Términos'}
                </span>
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-sage/10 transition-colors text-forest/60 hover:text-forest" aria-label="Cerrar" data-id="element-129">
                  <X className="h-5 w-5" data-id="element-130" />
                </button>
              </div>

              {/* Scrollable Content */}
              <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-64px)]" data-id="element-131">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}